import * as ActionTypes from "services/state/action-types";
import map from "ramda/src/map";
import fromPairs from "ramda/src/fromPairs";
import filter from "ramda/src/filter";

import _mapKeys from "lodash/mapKeys";
import _camelCase from "lodash/camelCase";
import _includes from "lodash/includes";
import * as Mask from "services/utils/mask";

const QUOTATION_INITIAL_STATE = {
  loading: false,
  error: false,
  quotationProducts: [],
  selectedProduct: [],
  configQuotationFields: [],
  summaryQuotation: [],
  quotationData: [],
};

const QuotationOptions = {
  mapAsOption: ({ value }) => {
    return { label: value, value };
  },

  mapAsPairs: ({ itemName, valueList }) => {
    const options = map(QuotationOptions.mapAsOption, valueList);
    return [itemName, options];
  },

  getOptions: (data) => {
    return normalizeObjKeys(fromPairs(map(QuotationOptions.mapAsPairs, data)));
  },

  hasValueListAttr: (item) => "valueList" in item,
};

const normalizeObjKeys = (obj) => {
  return _mapKeys(obj, (value, key) => _camelCase(key));
};

const SummaryDefinitions = {
  // TODO: PASSAR A PROPRIEDADE MESSAGEKEY PARA DENTRO DE RESULTDATA NO ACTION.PAYLOAD
  mapDataAsDefinition: (data) => {
    return [
      {
        key: "Viabilidade",
        value: _includes(data.messageKey, "feasible") ? "Viável" : "Inviável",
      },
      { key: "Protocolo", value: data.protocolNumber },
      {
        key: "Valor da mensalidade",
        value: `R$ ${Mask.numberToReal(data.recurrencyValue)}`,
      },
      {
        key: "Taxa de instalação",
        value: `R$ ${Mask.numberToReal(data.noRecurrencyValue)}`,
      },
    ];
  },
};

export function quotation(state = QUOTATION_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_QUOTATION_PRODUCTS:
    case ActionTypes.GET_CONFIG_QUOTATION_FIELDS:
    case ActionTypes.CREATE_QUOTATION:
    case ActionTypes.GET_QUOTATIONS_BY_PARAMS:
    case ActionTypes.DOWNLOAD_QUOTATIONS:
    case ActionTypes.SEND_QUOTATIONS_BY_EMAIL:
      return { ...state };

    case ActionTypes.GET_QUOTATION_PRODUCTS_SUCCESS:
      return { ...state, loading: false, quotationProducts: action.payload };

    case ActionTypes.GET_CONFIG_QUOTATION_FIELDS_SUCCESS:
      const data = filter(QuotationOptions.hasValueListAttr, action.payload);
      return {
        ...state,
        loading: false,
        configQuotationFields: QuotationOptions.getOptions(data),
      };

    case ActionTypes.CREATE_QUOTATION_SUCCESS:
      return {
        ...state,
        loading: false,
        summaryQuotation: SummaryDefinitions.mapDataAsDefinition(
          action.payload
        ),
      };

    case ActionTypes.GET_QUOTATIONS_BY_PARAMS_SUCCESS:
      return { ...state, loading: false, quotationData: action.payload };

    case ActionTypes.GET_QUOTATION_PRODUCTS_FAIL:
    case ActionTypes.GET_CONFIG_QUOTATION_FIELDS_FAIL:
    case ActionTypes.GET_QUOTATIONS_BY_PARAMS_FAIL:
    case ActionTypes.DOWNLOAD_QUOTATIONS_FAIL:
    case ActionTypes.SEND_QUOTATIONS_BY_EMAIL_FAIL:
      return { ...state, loading: false, error: true };

    case ActionTypes.SET_QUOTATION_PRODUCT:
      return { ...state, selectedProduct: action.selectedProduct };

    case ActionTypes.DOWNLOAD_QUOTATIONS_SUCCESS:
    case ActionTypes.SEND_QUOTATIONS_BY_EMAIL_SUCCESS:
      return { ...state, loading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/quotation/reducer.js